module.exports = __webpack_public_path__ + "static/media/19068_1318010717067_7228789_n.95d83fd0.jpg";